module.exports = __webpack_public_path__ + "static/media/Roboto-Black.45715786.ttf";